import { useTranslation } from '@jobcost-monorepo/i18n';
import { Button, Icon } from '@jobcost-monorepo/ui';
import { ReactElement } from 'react';

interface Props {
  handleCloseForm: () => void;
  disabled?: boolean;
  disabledReason?: string;
  /** Mostra "Riprova" (es. configurazione della fatturazione non leggibile). */
  onRetry?: () => void;
}

const InvoiceFormButtons = ({
  handleCloseForm,
  disabled = false,
  disabledReason,
  onRetry,
}: Props): ReactElement => {
  const { t } = useTranslation(['timesheets', 'commons']);

  return (
    <div className="flex flex-row justify-end items-center space-x-4 pt-4 px-4">
      {disabledReason && (
        <span className="text-sm text-gray-700 dark:text-white">
          {disabledReason}
        </span>
      )}
      {onRetry && (
        <Button type="button" variant="subtle" onClick={onRetry}>
          {t('commons:invoicingConfig.retry')}
        </Button>
      )}
      <Button type="button" variant="subtle" onClick={handleCloseForm}>
        <Icon iconName="cancel" className="dark:fill-white dark:stroke-white" />
        {t('invoice.form.cancel')}
      </Button>
      <Button type="submit" disabled={disabled}>
        <Icon iconName="confirm" className="fill-white stroke-white" />
        {t('invoice.form.invoice')}
      </Button>
    </div>
  );
};

export default InvoiceFormButtons;
